import {
  LOAD_MODEL,
  RESET_MODEL
} from "../constans";

const initState = {
    categories: null,
};

const viewerReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case LOAD_MODEL:

            return {
                ...state,
                ...payload
            };
        case RESET_MODEL:

            return {
                ...initState
            };
        default:
            return state;
    }
};
export default viewerReducer;
